/**
 * Theme delivery date picker — custom calendar dropdown.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cc_delivery_date';
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DAYS = ['Mo','Tu','We','Th','Fr','Sa','Su'];
  var MONTH_MAP = { jan:0, feb:1, mar:2, apr:3, may:4, jun:5, jul:6, aug:7, sep:8, oct:9, nov:10, dec:11 };

  function formatDisplayDate(isoDate) {
    if (!isoDate) return '';
    var parts = String(isoDate).split('-');
    if (parts.length !== 3) return isoDate;
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(d.getTime())) return isoDate;
    return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  }

  function getUkNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  }

  function tomorrowIso() {
    var d = getUkNow();
    d.setDate(d.getDate() + 1);
    return padIso(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function todayIso() {
    var uk = getUkNow();
    return padIso(uk.getFullYear(), uk.getMonth(), uk.getDate());
  }

  function padIso(year, month, day) {
    return year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
  }

  // Parses ship-date text such as "Ships on Jul 12, 2026" or "Jul 12, 2026".
  function parseShipsOnDate(str) {
    if (typeof window.ccParsePreorderShipDateFromText === 'function') {
      return window.ccParsePreorderShipDateFromText(str);
    }
    var m = String(str || '').match(/ships\s+on\s+([A-Za-z]+)\.?\s+(\d{1,2}),?\s*(\d{4})/i);
    if (!m) return null;
    var mo = MONTH_MAP[m[1].toLowerCase().slice(0, 3)];
    if (mo === undefined) return null;
    var d = new Date(parseInt(m[3], 10), mo, parseInt(m[2], 10));
    return isNaN(d.getTime()) ? null : d;
  }

  function parsePreorderShipDateFromProperties(props) {
    if (typeof window.ccParsePreorderShipDateFromProperties === 'function') {
      return window.ccParsePreorderShipDateFromProperties(props);
    }
    if (!props) return null;
    var latest = null;
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var d = parseShipsOnDate(keys[i]) || parseShipsOnDate(props[keys[i]]);
      if (d && (!latest || d > latest)) latest = d;
    }
    return latest;
  }

  /** True when cart line subtotal is zero (empty cart, or only $0 lines). */
  function cartSubtotalIsZero(cart) {
    if (!cart) return false;
    if (typeof cart.items_subtotal_price === 'number') {
      return cart.items_subtotal_price <= 0;
    }
    if (cart.item_count != null && cart.item_count === 0) return true;
    if (!Array.isArray(cart.items) || !cart.items.length) return true;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var line = it.final_line_price != null ? it.final_line_price : (it.line_price != null ? it.line_price : 0);
      sum += line;
    }
    return sum <= 0;
  }

  function latestPreorderShipDateFromCart(cart) {
    if (!cart || !cart.items) return null;
    var latest = null;
    for (var i = 0; i < cart.items.length; i++) {
      var d = parsePreorderShipDateFromProperties(cart.items[i].properties || {});
      if (d && (!latest || d > latest)) latest = d;
    }
    return latest;
  }

  function fetchCartSnapshot() {
    return typeof window.ccGetCartSnapshot === 'function'
      ? window.ccGetCartSnapshot()
      : fetch(cartRoot + '.js').then(function (r) { return r.ok ? r.json() : null; });
  }

  // Fetches the cart and returns the latest preorder ship Date across all line items, or null.
  function fetchLatestPreorderShipDate() {
    return fetchCartSnapshot()
      .then(latestPreorderShipDateFromCart)
      .catch(function () { return null; });
  }

  function clearDeliveryDateFromCartSnapshot() {
    if (typeof window.ccGetCartSnapshot !== 'function') return;
    window.ccGetCartSnapshot().then(function (cart) {
      if (!cart) return;
      if (!cart.attributes) cart.attributes = {};
      cart.attributes['Delivery Date'] = '';
      cart.attributes['__flare_delivery_date'] = '';
      cart.attributes['__flare_ship_date'] = '';
      if (typeof window.ccPublishCartSnapshot === 'function') {
        window.ccPublishCartSnapshot(cart, 'delivery-date-reset');
      }
    });
  }

  var _deliveryDateResetActive = false;

  function resetAllDeliveryDatePickers() {
    if (_deliveryDateResetActive) return;
    _deliveryDateResetActive = true;

    ++_selectGen;
    writeStoredDate('');
    _surchargeInCart = null;

    document.querySelectorAll('[data-ship-date-input]').forEach(function (input) {
      input.value = '';
    });

    document.querySelectorAll('cart-delivery-date-picker').forEach(function (picker) {
      if (typeof picker.closeCalendar === 'function') picker.closeCalendar();
      if (typeof picker.syncDisplay === 'function') picker.syncDisplay();
    });

    clearDeliveryDateFromCartSnapshot();
    updateCartAttribute('').finally(function () {
      _deliveryDateResetActive = false;
    });

    if (typeof window.syncCartDrawerCheckoutGate === 'function') {
      window.syncCartDrawerCheckoutGate();
    }
  }

  function readStoredDate() {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  function writeStoredDate(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, value);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  var cartRoot = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

  function shipDateFromDeliveryIso(isoDate) {
    if (!isoDate) return '';
    var parts = isoDate.split('-');
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    d.setDate(d.getDate() - 1);
    return padIso(d.getFullYear(), d.getMonth(), d.getDate());
  }

  // --- Cutoff + holiday schedule logic (ported from Slotify) ---

  function parseCutoffMinutes(cutoffTime) {
    var parts = String(cutoffTime || '17:00').split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10);
  }

  function parseHolidayList(raw) {
    if (!raw) return [];
    return String(raw).split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function dateToIso(date) {
    return padIso(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function getNormalDispatchDate(now, cutoffTime) {
    var cutoffMins = parseCutoffMinutes(cutoffTime);
    var nowMins = now.getHours() * 60 + now.getMinutes();
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (nowMins >= cutoffMins) d.setDate(d.getDate() + 1);
    return d;
  }

  function isWeekendDay(date) {
    var dow = date.getDay();
    return dow === 0 || dow === 6;
  }

  function findDispatchAndDelivery(dispatchStart, holidays) {
    var dispatch = new Date(dispatchStart.getTime());
    for (var i = 0; i < 21; i++) {
      var dispatchIso = dateToIso(dispatch);
      var delivery = addDays(dispatch, 1);
      var deliveryIso = dateToIso(delivery);
      // Weekends temporarily unavailable for delivery (Sat/Sun).
      if (
        holidays.indexOf(dispatchIso) === -1 &&
        holidays.indexOf(deliveryIso) === -1 &&
        !isWeekendDay(delivery)
      ) {
        return { dispatch: dispatch, delivery: delivery };
      }
      dispatch = addDays(dispatch, 1);
    }
    return { dispatch: dispatch, delivery: addDays(dispatch, 1) };
  }

  function computeDeliverySchedule(opts) {
    var now = opts.now || getUkNow();
    var cutoffTime = opts.cutoffTime || '17:00';
    var holidays = opts.holidays || [];
    var preorderShipDate = opts.preorderShipDate || null;

    var dispatchStart = getNormalDispatchDate(now, cutoffTime);

    if (preorderShipDate) {
      var preorderD = new Date(preorderShipDate.getFullYear(), preorderShipDate.getMonth(), preorderShipDate.getDate());
      if (preorderD > dispatchStart) dispatchStart = preorderD;
    }

    var pair = findDispatchAndDelivery(dispatchStart, holidays);
    var cutoffMins = parseCutoffMinutes(cutoffTime);
    var nowMins = now.getHours() * 60 + now.getMinutes();

    return {
      minDeliveryIso: dateToIso(pair.delivery),
      earliestDispatchIso: dateToIso(pair.dispatch),
      isBeforeCutoff: nowMins < cutoffMins
    };
  }

  function isDeliveryDateSelectable(isoDate, minDeliveryIso, earliestDispatchIso, holidays) {
    if (isoDate < minDeliveryIso) return false;
    var shipIso = shipDateFromDeliveryIso(isoDate);
    if (shipIso < earliestDispatchIso) return false;
    if (holidays.indexOf(isoDate) !== -1) return false;
    if (holidays.indexOf(shipIso) !== -1) return false;
    // Weekends temporarily unavailable for delivery (Sat/Sun).
    if (isWeekendDate(isoDate)) return false;
    return true;
  }

  // --- End schedule logic ---

  function buildDeliveryAttributes(isoDate) {
    var attrs = { 'Delivery Date': isoDate || '' };
    attrs['__flare_delivery_date'] = isoDate || '';
    attrs['__flare_ship_date'] = isoDate ? shipDateFromDeliveryIso(isoDate) : '';
    return attrs;
  }

  function updateCartAttribute(isoDate) {
    var body = { attributes: buildDeliveryAttributes(isoDate) };
    return fetch(cartRoot + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { return null; });
  }

  function getSurchargeVariantId() {
    var el = document.querySelector('[data-surcharge-variant-id]');
    var id = el && (el.dataset.surchargeVariantId || '').trim();
    return id || null;
  }

  function isWeekendDate(isoDate) {
    if (!isoDate) return false;
    var parts = isoDate.split('-');
    if (parts.length !== 3) return false;
    var dow = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)).getDay();
    return dow === 0 || dow === 6;
  }

  function triggerCartRerender() {
    _surchargeRerenderPending = true;
    // Clear flag after a generous window so normal cart changes resume state-tracking
    setTimeout(function () { _surchargeRerenderPending = false; }, 5000);
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl && typeof cartItemsEl.refreshCartItems === 'function') {
      cartItemsEl.refreshCartItems();
    }
  }

  // In-memory surcharge state: null=unknown, true=in cart, false=not in cart.
  // Avoids a GET /cart.js on every date change after the first.
  var _surchargeInCart = null;

  // Monotonic counter incremented on every doAdd/doRemove start.
  // Lets us detect when a newer operation supersedes an older one.
  var _surchargeSeq = 0;

  // When we trigger a cart re-render ourselves, suppress the on:cart:change
  // handler from resetting _surchargeInCart — our state is still correct.
  var _surchargeRerenderPending = false;

  // Generation counter incremented on every selectDate call.
  // The .then() callback checks this to skip stale completions.
  var _selectGen = 0;

  // Auto-corrects surcharge quantity if anything pushed it above 1.
  document.addEventListener('on:cart:change', function (e) {
    var src = e && e.detail && e.detail.source;
    // Don't reset state for re-renders we triggered ourselves — our state is still valid.
    if (src !== 'delivery-date-picker' && !_surchargeRerenderPending) {
      _surchargeInCart = null;
    }
    var variantId = getSurchargeVariantId();
    if (variantId) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && Array.isArray(cart.items)) {
        // Safety net: if the surcharge somehow ended up at qty > 1, clamp it immediately.
        var surchargeItem = cart.items.find(function (it) {
          return String(it.variant_id) === String(variantId);
        });
        if (surchargeItem && surchargeItem.quantity > 1) {
          var clamp = {};
          clamp[variantId] = 1;
          fetch(cartRoot + '/update.js', {
            method: 'POST',
            headers: _surchargeHeaders,
            body: JSON.stringify({ updates: clamp })
          });
        }
      }
    }
  });

  var _surchargeHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  // Adds or removes the surcharge variant as needed.
  // Fast path (state known): 1 API call. Slow path (first call): GET then conditional POST.
  // Resolves to true if the cart was modified, false otherwise.
  function syncSurchargeVariant(isoDate) {
    var variantId = getSurchargeVariantId();
    if (!variantId) return Promise.resolve(false);

    var needsWeekend = isWeekendDate(isoDate);

    function doAdd() {
      var mySeq = ++_surchargeSeq;
      // Set optimistically before the fetch so concurrent calls use the fast path
      // and don't fire a second add.js while this one is in flight.
      _surchargeInCart = true;
      return fetch(cartRoot + '/add.js', {
        method: 'POST',
        headers: _surchargeHeaders,
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) {
        if (mySeq < _surchargeSeq) return false; // newer op took over, don't touch state
        // Parse response to detect if concurrent adds pushed qty above 1.
        return r.json().then(function (added) {
          var needsClamp = added && typeof added.quantity === 'number' && added.quantity > 1;
          if (needsClamp) {
            // A parallel add slipped through — clamp to exactly 1 and set attribute together.
            var clampUpdates = {};
            clampUpdates[variantId] = 1;
            return fetch(cartRoot + '/update.js', {
              method: 'POST',
              headers: _surchargeHeaders,
              body: JSON.stringify({ updates: clampUpdates, attributes: buildDeliveryAttributes(readStoredDate()) })
            }).then(function () { return true; });
          }
          // Use readStoredDate() — the user may have changed selection while we were in-flight
          return updateCartAttribute(readStoredDate()).then(function () { return true; });
        }).catch(function () {
          // Response was not JSON (e.g. already at qty=1); proceed normally.
          return updateCartAttribute(readStoredDate()).then(function () { return true; });
        });
      }).catch(function () {
        if (mySeq === _surchargeSeq) _surchargeInCart = null; // reset on failure
        return false;
      });
    }

    function doRemove() {
      var mySeq = ++_surchargeSeq;
      // Set optimistically before the fetch
      _surchargeInCart = false;
      var updates = {};
      updates[variantId] = 0;
      // Use readStoredDate() so the attribute always reflects the current selection
      var currentDate = readStoredDate();
      return fetch(cartRoot + '/update.js', {
        method: 'POST',
        headers: _surchargeHeaders,
        body: JSON.stringify({ updates: updates, attributes: buildDeliveryAttributes(currentDate) })
      }).then(function () {
        if (mySeq < _surchargeSeq) return false; // newer op took over
        return true;
      }).catch(function () {
        if (mySeq === _surchargeSeq) _surchargeInCart = null;
        return false;
      });
    }

    // Fast path: state is known — skip the cart GET
    if (_surchargeInCart !== null) {
      if (needsWeekend && _surchargeInCart)  return Promise.resolve(false);
      if (!needsWeekend && !_surchargeInCart) return Promise.resolve(false);
      return needsWeekend ? doAdd() : doRemove();
    }

    // Slow path: state unknown — share the in-flight GET with any other concurrent callers
    return fetchCartSnapshot().then(function (cart) {
        if (!cart) return false;

        // A concurrent call may have already updated _surchargeInCart optimistically while
        // this GET was in-flight. Don't clobber it — only initialise if still unknown.
        // Without this guard, two concurrent slow-path callers sharing the same GET both
        // set _surchargeInCart = false and both call doAdd(), resulting in qty = 2.
        if (_surchargeInCart === null) {
          _surchargeInCart = cart.items.some(function (it) {
            return String(it.variant_id) === String(variantId);
          });
        }

        var inCart = _surchargeInCart;
        if (needsWeekend && !inCart)  return doAdd();
        if (!needsWeekend && inCart)  return doRemove();
        return false;
      })
      .catch(function () { return false; });
  }

  if (!customElements.get('cart-delivery-date-picker')) {
    class CartDeliveryDatePicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.context = this.dataset.context || 'drawer';
        this.weekendSurcharge = (this.dataset.weekendSurcharge || '').trim();
        this.cutoffTime = (this.dataset.cutoffTime || '17:00').trim();
        this.holidays = parseHolidayList(this.dataset.holidays || '');
        this.input = this.querySelector('[data-ship-date-input]');
        this.display = this.querySelector('[data-delivery-date-display]');
        if (!this.input) return;

        var initSchedule = computeDeliverySchedule({
          cutoffTime: this.cutoffTime,
          holidays: this.holidays,
          preorderShipDate: null
        });
        this.minDate = initSchedule.minDeliveryIso;
        this.earliestDispatchIso = initSchedule.earliestDispatchIso;
        this.input.min = this.minDate;

        this._open = false;
        this._viewYear = null;
        this._viewMonth = null;

        this._card = this.querySelector('.cart-delivery-date-picker__figma-card');

        var container = this.closest('[data-cc-postcode-date-container]');
        this._postcodeChecker = container ? container.querySelector('cart-postcode-checker') : null;

        this._popup = document.createElement('div');
        this._popup.className = 'cc-datepicker-popup';
        this._popup.setAttribute('hidden', '');
        (this._card || this).appendChild(this._popup);

        this._postcodeMsg = document.createElement('p');
        this._postcodeMsg.className = 'cc-datepicker-postcode-msg';
        this._postcodeMsg.setAttribute('hidden', '');
        this._postcodeMsg.textContent = 'Please enter a postcode first.';
        this.appendChild(this._postcodeMsg);

        this.syncDisplay();
        this.bindEvents();

        // Optimistically restore the stored date using the synchronous initSchedule min date
        // so the checkout button is enabled immediately without waiting for fetchCartSnapshot.
        // applyCartMinDate will correct/clear it if the preorder min date makes it invalid.
        var storedEarly = readStoredDate();
        if (storedEarly && isDeliveryDateSelectable(storedEarly, initSchedule.minDeliveryIso, initSchedule.earliestDispatchIso, this.holidays)) {
          this.input.value = storedEarly;
          if (typeof window.syncCartDrawerCheckoutGate === 'function') window.syncCartDrawerCheckoutGate();
        }

        // Compute real minDate from cart (handles preorder) then restore stored date
        this.applyCartMinDate(true);
      }

      bindEvents() {
        var self = this;

        var card = this.querySelector('.cart-delivery-date-picker__figma-card');
        if (card) {
          card.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!self._hasPostcode()) {
              self._showPostcodeRequired();
              return;
            }
            self._open ? self.closeCalendar() : self.openCalendar();
          });
        }

        this._popup.addEventListener('click', function (e) {
          e.stopPropagation();
          var prev = e.target.closest('[data-cc-prev]');
          var next = e.target.closest('[data-cc-next]');
          var day  = e.target.closest('[data-cc-date]');
          if (prev && !prev.disabled) {
            if (--self._viewMonth < 0) { self._viewMonth = 11; self._viewYear--; }
            self.renderCalendar();
          } else if (next) {
            if (++self._viewMonth > 11) { self._viewMonth = 0; self._viewYear++; }
            self.renderCalendar();
          } else if (day && !day.disabled) {
            self.selectDate(day.dataset.ccDate);
          }
        });

        this._onDocClick = function (e) {
          if (self._open && !self.contains(e.target)) self.closeCalendar();
        };
        document.addEventListener('click', this._onDocClick);

        this._onDocKeydown = function (e) {
          if (e.key === 'Escape' && self._open) self.closeCalendar();
        };
        document.addEventListener('keydown', this._onDocKeydown);

        // Re-evaluate preorder min date whenever cart changes (item added/removed)
        this._onCartChange = function (e) {
          var cart = e && e.detail && e.detail.cart;
          var vid = getSurchargeVariantId();

          // If the surcharge is the only remaining item, clear date and auto-remove it
          if (vid && cart && Array.isArray(cart.items)) {
            var hasRealItems = cart.items.some(function (it) {
              return String(it.variant_id) !== String(vid);
            });
            var surchargeInCart = cart.items.some(function (it) {
              return String(it.variant_id) === String(vid);
            });
            if (!hasRealItems && surchargeInCart) {
              resetAllDeliveryDatePickers();
              _surchargeInCart = true;
              syncSurchargeVariant('').then(function (changed) {
                if (changed) triggerCartRerender();
                if (typeof window.syncCartDrawerCheckoutGate === 'function') window.syncCartDrawerCheckoutGate();
              });
              return;
            }
          }

          if (cart && cartSubtotalIsZero(cart)) {
            resetAllDeliveryDatePickers();
            return;
          }

          self.applyCartMinDate(false);
        };
        document.addEventListener('on:cart:change', this._onCartChange);
      }

      disconnectedCallback() {
        if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
        if (this._onDocKeydown) document.removeEventListener('keydown', this._onDocKeydown);
        if (this._onCartChange) document.removeEventListener('on:cart:change', this._onCartChange);
      }

      // Fetches cart to determine the correct min selectable date.
      // If a preorder line item exists, minDate = day after latest ship date.
      // isInit=true: also restores stored date and syncs surcharge silently.
      applyCartMinDate(isInit) {
        var self = this;
        fetchCartSnapshot().then(function (cart) {
          if (cartSubtotalIsZero(cart)) {
            resetAllDeliveryDatePickers();
            return;
          }

          // If only the surcharge is in the cart (no real items), reset and remove it.
          // This handles page loads after /cart/clear where the surcharge may have survived
          // or be re-added by stale sessionStorage state before real items are confirmed gone.
          var surchargeId = getSurchargeVariantId();
          if (surchargeId && cart && Array.isArray(cart.items) && cart.items.length > 0) {
            var hasRealItems = cart.items.some(function (it) {
              return String(it.variant_id) !== String(surchargeId);
            });
            if (!hasRealItems) {
              resetAllDeliveryDatePickers();
              _surchargeInCart = true;
              syncSurchargeVariant('').then(function (changed) {
                if (changed) triggerCartRerender();
                if (typeof window.syncCartDrawerCheckoutGate === 'function') window.syncCartDrawerCheckoutGate();
              });
              return;
            }
          }

          var preorderDate = latestPreorderShipDateFromCart(cart);
          var schedule = computeDeliverySchedule({
            cutoffTime: self.cutoffTime,
            holidays: self.holidays,
            preorderShipDate: preorderDate
          });
          var minDate = schedule.minDeliveryIso;

          self.minDate = minDate;
          self.earliestDispatchIso = schedule.earliestDispatchIso;
          self.input.min = minDate;

          if (isInit) {
            // On first load: restore stored date if still valid against new schedule
            var stored = readStoredDate();
            if (stored && isDeliveryDateSelectable(stored, minDate, schedule.earliestDispatchIso, self.holidays)) {
              self.input.value = stored;
              syncSurchargeVariant(stored).then(function (changed) {
                if (changed) triggerCartRerender();
                if (typeof window.syncCartDrawerCheckoutGate === 'function') window.syncCartDrawerCheckoutGate();
              });
            } else if (stored) {
              // Stored date is now invalid (past, before preorder ships, or holiday) — clear it
              writeStoredDate('');
              self.input.value = '';
            }
            self.syncDisplay();
          } else {
            // Cart changed while picker is live: if current selection is now invalid, clear it
            var current = self.input.value;
            if (current && !isDeliveryDateSelectable(current, minDate, schedule.earliestDispatchIso, self.holidays)) {
              self.input.value = '';
              writeStoredDate('');
              self.syncDisplay();
            }
          }

          if (typeof window.syncCartDrawerCheckoutGate === 'function') {
            window.syncCartDrawerCheckoutGate();
          }
        }).catch(function () {});
      }

      _hasPostcode() {
        if (this._postcodeChecker) {
          var input = this._postcodeChecker.querySelector('[data-postcode-input]');
          var summaryVal = this._postcodeChecker.querySelector('[data-postcode-summary-value]');
          var val = (input && input.value.trim()) || (summaryVal && summaryVal.textContent.trim()) || '';
          return val.length > 0;
        }
        return !!window.ccPostcodeShippingRatesValid;
      }

      _showPostcodeRequired() {
        var msg = this._postcodeMsg;
        if (!msg) return;
        if (this._postcodeMsg._timer) clearTimeout(this._postcodeMsg._timer);
        msg.removeAttribute('hidden');
        msg.classList.add('cc-datepicker-postcode-msg--visible');
        var self = this;
        this._postcodeMsg._timer = setTimeout(function () {
          msg.classList.remove('cc-datepicker-postcode-msg--visible');
          msg.setAttribute('hidden', '');
        }, 3000);
      }

      // True if the month has at least one selectable delivery date
      _monthHasSelectable(yr, mo) {
        var days = new Date(yr, mo + 1, 0).getDate();
        for (var d = 1; d <= days; d++) {
          if (isDeliveryDateSelectable(padIso(yr, mo, d), this.minDate, this.earliestDispatchIso, this.holidays)) return true;
        }
        return false;
      }

      openCalendar() {
        var sel = this.input.value;
        var d = sel ? new Date(sel + 'T00:00:00') : getUkNow();
        this._viewYear  = d.getFullYear();
        this._viewMonth = d.getMonth();
        // Skip forward past months with no selectable dates (e.g. cutoff pushes delivery to next month)
        for (var i = 0; i < 12 && !this._monthHasSelectable(this._viewYear, this._viewMonth); i++) {
          if (++this._viewMonth > 11) { this._viewMonth = 0; this._viewYear++; }
        }
        this.renderCalendar();
        this._popup.removeAttribute('hidden');
        this._open = true;

        // Flip above if below-fold
        var self = this;
        requestAnimationFrame(function () {
          var rect = self._popup.getBoundingClientRect();
          if (rect.bottom > window.innerHeight - 8) {
            self._popup.style.top  = 'auto';
            self._popup.style.bottom = 'calc(100% + 6px)';
          } else {
            self._popup.style.bottom = '';
            self._popup.style.top = '';
          }
        });
      }

      closeCalendar() {
        this._popup.setAttribute('hidden', '');
        this._popup.style.bottom = '';
        this._popup.style.top = '';
        this._open = false;
      }

      renderCalendar() {
        var yr  = this._viewYear;
        var mo  = this._viewMonth;
        var today    = todayIso();
        var minDate  = this.minDate;
        var earliestDispatchIso = this.earliestDispatchIso;
        var holidays = this.holidays;
        var selected = this.input.value || '';

        var firstDow    = (new Date(yr, mo, 1).getDay() + 6) % 7;
        var daysInMonth = new Date(yr, mo + 1, 0).getDate();

        var html = '';

        // Header — disable prev when the previous month has no selectable dates
        var prevMo = mo === 0 ? 11 : mo - 1;
        var prevYr = mo === 0 ? yr - 1 : yr;
        var prevDisabled = !this._monthHasSelectable(prevYr, prevMo);

        html += '<div class="cc-dp__header">';
        html += '<button type="button" class="cc-dp__nav" data-cc-prev aria-label="Previous month"'
          + (prevDisabled ? ' disabled' : '') + '>'
          + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">'
          + '<path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg></button>';
        html += '<strong class="cc-dp__title">' + MONTHS[mo] + ' ' + yr + '</strong>';
        html += '<button type="button" class="cc-dp__nav" data-cc-next aria-label="Next month">'
          + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">'
          + '<path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg></button>';
        html += '</div>';

        // Weekday row
        html += '<div class="cc-dp__weekdays">';
        for (var wi = 0; wi < 7; wi++) {
          html += '<span>' + DAYS[wi] + '</span>';
        }
        html += '</div>';

        // Day grid
        html += '<div class="cc-dp__grid">';

        // Leading ghost cells (prev month)
        for (var li = 0; li < firstDow; li++) {
          html += '<span class="cc-dp__day cc-dp__day--ghost"></span>';
        }

        // Current month
        var surcharge = this.weekendSurcharge;
        for (var d = 1; d <= daysInMonth; d++) {
          var iso = padIso(yr, mo, d);
          var dow = new Date(yr, mo, d).getDay();
          var isWeekend = dow === 0 || dow === 6;
          var isDisabled = !isDeliveryDateSelectable(iso, minDate, earliestDispatchIso, holidays);
          var cls = 'cc-dp__day';
          if (isWeekend && !isDisabled) cls += ' cc-dp__day--weekend';
          if (isDisabled)  cls += ' cc-dp__day--disabled';
          if (iso === today)  cls += ' cc-dp__day--today';
          if (iso === selected) cls += ' cc-dp__day--selected';

          var surchargeHtml = (isWeekend && surcharge && !isDisabled)
            ? '<span class="cc-dp__surcharge">+' + surcharge + '</span>'
            : '';

          var btn = isDisabled ? 'span' : 'button type="button"';
          var endTag = isDisabled ? 'span' : 'button';
          html += '<' + btn + ' class="' + cls + '" data-cc-date="' + iso + '">' + d + surchargeHtml + '</' + endTag + '>';
        }

        // Trailing ghost cells
        var total = firstDow + daysInMonth;
        var rem   = total % 7;
        if (rem > 0) {
          for (var ti = 1; ti <= 7 - rem; ti++) {
            html += '<span class="cc-dp__day cc-dp__day--ghost"></span>';
          }
        }

        html += '</div>';
        this._popup.innerHTML = html;
      }

      selectDate(iso) {
        var gen = ++_selectGen;
        this.input.value = iso;
        writeStoredDate(iso);
        this.syncDisplay();
        this.closeCalendar();

        syncSurchargeVariant(iso).then(function (changed) {
          if (_selectGen !== gen) {
            // Stale: a newer selectDate is now active. Only rerender if the surcharge
            // state changed AND the current date still needs the same surcharge state —
            // e.g. weekend→weekend rapid switch where the first doAdd finishes late.
            if (changed && _surchargeInCart && isWeekendDate(readStoredDate())) {
              triggerCartRerender();
            }
            return;
          }
          // If the surcharge didn't change, still persist the attribute (doAdd/doRemove handle it when changed=true).
          if (!changed) updateCartAttribute(iso);
          if (changed) triggerCartRerender();
          if (typeof window.syncCartDrawerCheckoutGate === 'function') window.syncCartDrawerCheckoutGate();
        });
      }

      syncDisplay() {
        if (!this.display || !this.input) return;
        var value = String(this.input.value || '').trim();
        var placeholder =
          (window.theme && window.theme.strings && window.theme.strings.postcodeChooseDeliveryDate) ||
          'Choose Delivery Date';
        this.display.textContent = value ? formatDisplayDate(value) : placeholder;
        this.classList.toggle('cart-delivery-date-picker--has-value', !!value);
      }
    }

    customElements.define('cart-delivery-date-picker', CartDeliveryDatePicker);
  }
})();
